import React, { useMemo, useState, useEffect, useContext } from "react";
import { Grid, Box } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { setSex as updateSex } from "../../redux/userSlice";
import { useNavigate } from "react-router-dom";
import Question from "../../components/Question";
import MoveButton from "../../components/MoveButton";
import { MinorUserContext } from "../../context/UserNameProvider";
import { calculateAge } from "../../lib/utils";
import setPageAndDeferNavigate from "../../lib/setPageAndDeferNavigate";

export default function SexAtBirth(props) {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const user = useSelector((state) => state.user);
    const { isMinor, firstName } = useContext(MinorUserContext);

    const [age, setAge] = useState(null);

    useEffect(() => {
        setAge(calculateAge(user?.dob));
    }, [user]);

    const sexOptions = useMemo(
        () => ({
            "Male": "Male",
            "Female": "Female",
            "Prefer not to say": "Prefer not to say"
        }),
        []
    );

    // accutane
    const showBirthControl = user.concern === "Acne" &&
        user.treatmentContinuation?.interestedInAccutane === 'Y' && (user.address.state === 'CT' || user.address.state === 'MA');

    const handleBack = () => {
        setPageAndDeferNavigate(dispatch, '/duration', navigate);
    };

    return (
        <Question
            onBack={handleBack}
            title={`What was ${isMinor ? `${firstName}'s` : "your"} sex assigned at birth?`}
            subtitle={isMinor ? "If you're seeking care for a minor, enter their relevant information." : ""}
            input={
                <Box
                    sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                    }}
                >
                    <Grid
                        container
                        spacing={2}
                        sx={{
                            width: { xs: "100%", sm: "80%", md: "70%" },
                            maxWidth: 600,
                            justifyContent: "center",
                        }}
                    >
                        {Object.keys(sexOptions)
                            .filter(key => key !== "Prefer not to say")
                            // TBD - accutane
                            .filter(key => !showBirthControl || key !== "Prefer not to say")
                            .map((key) => (
                                <Grid
                                    item
                                    xs={12}
                                    key={key}
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <MoveButton
                                        sx={{ width: "100%", maxWidth: "500px" }}
                                        onClick={() => {
                                            dispatch(updateSex({ ...user.sex, sexAtBirth: sexOptions[key] }));
                                            if (sexOptions[key] === "Male") {
                                                // TBD - accutane
                                                if (user.treatmentContinuation?.interestedInAccutane === 'Y' && (user.address.state === 'CT' || user.address.state === 'MA')) {
                                                  setPageAndDeferNavigate(dispatch, '/last-period-date', navigate);
                                                } else {
                                                    setPageAndDeferNavigate(dispatch, '/allergies', navigate);
                                                }
                                            }
                                            else {
                                                if (age > 18) {
                                                    setPageAndDeferNavigate(dispatch, '/menstrual', navigate);
                                                }
                                                else {
                                                    setPageAndDeferNavigate(dispatch, '/maternity', () =>
                                                        navigate('/maternity', { state: { returning: false } })
                                                    );
                                                }
                                            }
                                        }}
                                        title={key}
                                        selected={sexOptions[key] === user.sex.sexAtBirth}
                                    />
                                </Grid>
                            ))}
                    </ Grid>
                </Box>
            }
        />
    );
}